import { render, staticRenderFns } from "./academic_schdual_refereesystem_final.vue?vue&type=template&id=ec116f62&scoped=true&"
import script from "./academic_schdual_refereesystem_final.vue?vue&type=script&lang=js&"
export * from "./academic_schdual_refereesystem_final.vue?vue&type=script&lang=js&"
import style0 from "./academic_schdual_refereesystem_final.vue?vue&type=style&index=0&id=ec116f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec116f62",
  null
  
)

export default component.exports